import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import CommunityViewItemDetails from "./CommunityViewItemDetails"
import CommunityViewParticipantsContainer from "./participants/CommunityViewParticipantsContainer"
import CommunityViewLabels from "./CommunityViewLabels"
import CommunityViewEditorMetadata from "./CommunityViewEditorMetadata"
import CommunityViewHierarchy from "./CommunityViewHierarchy"
import CommunityViewRelatedItems from "./CommunityViewRelatedItems"

const CommunityViewItem = ({
    model,
    communityId,
    participantType,
    isFetching
}) => (
    <ItemDetailsColumns>
        <ItemDetailsColumn>
            <CommunityViewItemDetails
                name={model.name}
                description={model.description}
                status={model.status}
                privacy={model.privacy}
                image_url={model.image_url}
                open_feed={model.open_feed}
                isFetching={isFetching}
            />
            <CommunityViewLabels
                labels={model.labels}
                systemLabels={model.system_labels}
                isFetching={isFetching}
            />
            <CommunityViewEditorMetadata
                creator={model.creator}
                time={model.time}
                source={model.source}
                updatedBy={model.updated_by}
                lastUpdated={model.last_updated}
                isFetching={isFetching}
            />
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <CommunityViewHierarchy
                parent={model.parent}
                subGroups={model.sub_groups}
                subCommunities={model.sub_communities}
                reference={model.reference}
                isFetching={isFetching}
            />
            <CommunityViewRelatedItems
                topics={model.topics}
                dimensions={model.dimensions}
                communities={model.communities}
                projects={model.projects}
                isFetching={isFetching}
            />
            <div className="community-participants-panel">
                <CommunityViewParticipantsContainer
                    type={participantType}
                    communityId={communityId}
                />
            </div>
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default CommunityViewItem
